module.exports = __webpack_public_path__ + "b978b653bd7e88792cdcda5e44c23d4f.png";